const zh_tw = require("./apexLocales/zh-tw.json")
export default class CONST {
  static sumPeopleFlow = {
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
   
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      curve: "smooth",
      dashArray: 0,
    },
    title: {
      text: "人數",
      align: "left",
    },
    legend: {
      fontSize: '12px',
      onItemClick: {
        toggleDataSeries: false
      }
      // tooltipHoverFormatter: function (val, opts) {
      //   return (
      //     val +
      //     " - " +
      //     opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //     ""
      //   );
      // },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      type: "datetime",
      tooltip:{
        enabled: false
      },
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              day: "MM/dd",
              hour: "HH",
            },
          },

      categories: [
      ],
    },
    tooltip: {
      x: {
        format: undefined,
        formatter:undefined
      },
      y: [
        // {
        //   title: {
        //     formatter: function (val) {
        //       return val ;
        //     },
        //   },
        // },
        // {
        //   title: {
        //     formatter: function (val) {
        //       return val + "(位)";
        //     },
        //   },
        // },
        // {
        //   title: {
        //     formatter: function (val) {
        //       return val + "(位)";
        //     },
        //   },
        // },
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }
}